export default __webpack_public_path__ + "static/media/719.63c3061c.png";